import React from 'react';
import { useLoaderData } from 'react-router-dom';

const CheckOut = () => {
    const course = useLoaderData();
    const { title, price} = course;
    return (
        <div className="text-center my-5">
                                <p className="text-info">{title} <br /> Price: BDT {price}</p>
                            </div>
    );
};

export default CheckOut;